import { Pipe, PipeTransform } from '@angular/core';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { forEach } from 'lodash-es';


// see https://stackoverflow.com/questions/33781510/how-to-replace-in-javascript

@Pipe({
  name: 'imageResized'
})
export class ImageResizedPipe implements PipeTransform {
  private div:HTMLElement;
  constructor () {
    this.div = document.createElement('div')
  }

  transform(value: string): string {
    if (typeof value === 'string') {
      this.div.innerHTML = value;
      const images = Array.from(this.div.querySelectorAll('img'));
      images.forEach(img=>{
        if (!img.src) return;

        const matched = img.src.match(/v5.schoolbell-e.com\/api\/file\/([\d]+:[\d]+)/)
        if (!matched) return;
        
        // logic to determine proper size should come here
        let res:string = 'high';
        // logic to determine proper size should come here

        img.src = `https://v5.schoolbell-e.com/api/file/image/${matched[1]}?size=${res}`;
      });
      return this.div.innerHTML;
    }
    return value || '';
  }
}
